// @flow

import { SemanticSearch, ProductPerformanceRanking } from 'src/models/search';

const markUsed = (...args: Array<mixed>): void => {
  void args;
};

// Init Full Story
const initFullStory = () => {};

/**
 * Set user property from tenant
 */
const setupFullStoryUser = tenantApp => {
  markUsed(tenantApp);
};

/**
 * Track event
 */
const trackFSEvent = (name, properties) => {
  markUsed(name, properties);
};

/**
 * Track specific events
 */
const trackFSEvent_UpdateFilterSettings = (type: String, data: Record<String, any>): void => {
  markUsed(type, data);
};

const trackFSEvent_SelectAnalyticsFrame = () => {};

const trackFSEvent_UpdateRelevanceSearchSetting = (
  currentSearchSetting: Record<String, any>,
  newSearchSetting: Record<String, any>
) => {
  markUsed(currentSearchSetting, newSearchSetting);
};

const trackFSEvent_SemanticSearch = (oldSettings: SemanticSearch, settings: SemanticSearch) => {
  markUsed(oldSettings, settings);
};

const trackFSEvent_ProductPerformanceRanking = (
  oldSettings: ProductPerformanceRanking,
  settings: ProductPerformanceRanking
) => {
  markUsed(oldSettings, settings);
};

const trackFSEvent_Personalization = (
  oldSettings: Record<String, any>,
  settings: Record<String, any>
) => {
  markUsed(oldSettings, settings);
};

/**
 * Track merchandising operations (create, update, delete, etc.)
 * @param {string} eventName - Event name to track
 * @param {Object} rule - Merchandising rule object
 */
const trackFSEvent_Merchandising = (eventName: string, rule: Object) => {
  markUsed(eventName, rule);
};

const trackFSEvent_ChangeThemeElement = (
  oldSetting: Record<String, any>,
  newSetting: Record<String, any>,
  themeName: string,
  addedElements: Record<String, any>[],
  removedElements: Record<String, any>[]
): void => {
  markUsed(oldSetting, newSetting, themeName, addedElements, removedElements);
};

const trackFSEvent_ChangeSSRVisualEditor = (
  selectedTemplate: string,
  templateId: string,
  settings: Object
): void => {
  markUsed(selectedTemplate, templateId, settings);
};

const trackFSEvent_ChangeCodeEditor = (
  selectedTemplate: string,
  templateId: string,
  editedWidget: Object
): void => {
  markUsed(selectedTemplate, templateId, editedWidget);
};
export {
  initFullStory,
  setupFullStoryUser,
  trackFSEvent,
  trackFSEvent_UpdateFilterSettings,
  trackFSEvent_SelectAnalyticsFrame,
  trackFSEvent_UpdateRelevanceSearchSetting,
  trackFSEvent_SemanticSearch,
  trackFSEvent_ProductPerformanceRanking,
  trackFSEvent_Personalization,
  trackFSEvent_Merchandising,
  trackFSEvent_ChangeThemeElement,
  trackFSEvent_ChangeSSRVisualEditor,
  trackFSEvent_ChangeCodeEditor
};
